<template>
	<div :style="{ '--background-color': backgroundColor }" class="stat-item">
		<div v-if="$slots.icon || icon" class="stat-icon">
			<slot name="icon">
				<img :src="icon" class="icon" />
			</slot>
		</div>
		<div class="stat-label">{{ label }}</div>
		<div class="stat-value">
			<span class="value-text">
				<slot>{{ value || value === 0 ? value : '--' }}</slot>
			</span>
			<span v-if="unit" class="value-unit">{{ unit }}</span>
			<img v-if="hasTrend && trendIcon" :src="trendIcon" class="trend-icon" />
		</div>
	</div>
</template>

<script>
import rise from '../icons/rise.svg'
import decline from '../icons/decline.svg'

export default {
	name: 'StatCard',
	props: {
		label: { type: String, required: true },
		value: { type: [String, Number], default: '' },
		unit: { type: String, default: '' },
		trend: { type: Number, default: null },
		icon: { type: [Object, String], default: null },
		backgroundColor: { type: String, default: '#f8f9fa' },
	},
	computed: {
		hasTrend() {
			return this.trend !== null && this.trend !== undefined
		},
		trendIcon() {
			if (this.trend === 0) return null
			return this.trend > 0 ? rise : decline
		},
	},
}
</script>

<style scoped lang="scss">
.stat-item {
	display: flex;
	padding: 12px;
	background: var(--background-color);
	border-radius: 4px;
	width: 100%;
	min-height: 50px;
	display: flex;
	align-items: center;
	gap: 12px;

	.stat-icon {
		width: 32px;
		height: 32px;

		.icon {
			width: 100%;
			height: 100%;
			margin: 0;
		}
	}

	.stat-label {
		font-size: 13px;
		color: #606266;
		font-style: italic;
		white-space: nowrap;
	}

	.stat-value {
		font-size: 15px;
		font-weight: bold;
		color: #303133;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 3px;
		margin-left: auto;

		.value-unit {
			font-size: 13px;
			color: #999999;
			font-style: italic;
			font-weight: 100;
			padding-top: 4px;
		}
	}

	.trend-icon {
		width: 27px;
		height: 27px;
		margin-left: 6px;
	}
}
</style>
